import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-review-reason',
  templateUrl: './review-reason.component.html',
  styleUrls: ['./review-reason.component.css'],
})
export class ReviewReasonComponent implements OnInit {
  reasonForm: FormGroup;
  datas;
  private saveApi = environment.url + environment.updateStatus;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<ReviewReasonComponent>
  ) {
    this.reasonForm = this.fb.group({
      reason: ['', [Validators.required]],
      incubatorId: [''],
    });
    this.datas = data;
    const fc = new FormControl('');
    this.reasonForm.addControl(this.datas._key, fc);
    this.reasonForm.controls[this.datas._key].setValue(this.datas._status);
    let getform = this.reasonForm.value;
    getform.incubatorId = sessionStorage.getItem('incubator');
    this.reasonForm.patchValue(getform);
  }
  get add() {
    return this.reasonForm.controls;
  }
  ngOnInit(): void {}
  // API endpoint to save rejection reason
  saveReason() {
    let getform = this.reasonForm.value;
    if (this.reasonForm.invalid) {
      this.reasonForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.cancelReason();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  // Cancel
  cancelReason() {
    this.reasonForm.reset();
    this.dialogRef.close();
  }
}
